import React from 'react';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { AccessibilityStyles } from '../styles/accessibility';

interface AccessibilityHelpProps {
  onContinueClick?: () => void;
}

export const AccessibilityHelp = ({ onContinueClick }: AccessibilityHelpProps): JSX.Element => {
  const { t } = useTranslation();
  // const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const classes = AccessibilityStyles();
  const link = '';
  const message1 = t('accessibilityHelpModalMessage1'); // intro
  const message2 = t('accessibilityHelpModalMessage2'); // examples
  const message3 = t('accessibilityHelpModalMessage3'); // list:
  const message4 = t('accessibilityHelpModalMessage4');
  const message5 = t('accessibilityHelpModalMessage5');
  const message6 = t('accessibilityHelpModalMessage6');
  const message7 = t('accessibilityHelpModalMessage7');
  const message8 = t('accessibilityHelpModalMessage8');
  const message8b = t('accessibilityHelpModalMessage8.1');
  const message9 = t('accessibilityHelpModalMessage9'); // big paragraph
  const message10 = t('accessibilityHelpModalMessage10'); // text before link
  const message11 = t('accessibilityHelpModalMessage11'); // support link

  return (
    <div className={classes.screenContent}>
      <div className="screen-box theme-bg-header" data-testid="accessibility-screen">
        <div className="theme-bg-header accessibility-screen" role="main">
          <div className={`screen-text${''}`}>
            <p>{message1}</p>
            <p>{message2}</p>
            <p>
              {message3}
              <br />
              {message4}
              <br />
              {message5}
              <br />
              {message6}
              <br />
              {message7}
              <br />
              {message8}
              <br />
              {message8b}
              <br />
            </p>
            <p>{message9}</p>
            <p>
              {message10}
              <a href={link} target="_blank" rel="noopener noreferrer">
                {message11}
              </a>
            </p>
          </div>
        </div>
        <div className={`screen-footer button-wrapper theme-bg-header accessibility-footer`}>
          <Button variant="outlined" color="primary" className="continueBtn" onClick={onContinueClick}>
            {t('continue')}
          </Button>
        </div>
      </div>
    </div>
  );
};
